export default "__VITE_ASSET__FFl5YdSa__"